export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect x="4.5" y="4.5" width="23" height="23" rx="2.16667" stroke="#DDDDDD" />
        </svg>
    );
}
